export default (mergedCounts, { firstWorkShift, secondWorkShift }, shiftDate) => {
  for (let count in mergedCounts) {
    const isFirstWorkShift = mergedCounts[count].forceTime < shiftDate
    const { userId, parkings } = SelectRandomEmployee(isFirstWorkShift ? firstWorkShift : secondWorkShift)
    const parking = SelectRandomParking(parkings)

    mergedCounts[count].parkingPlace.parking = parking
    mergedCounts[count].userId = userId
  }
  return true
}

const SelectRandomEmployee = (employeeList) => {
  const randomNumber = Math.ceil(Math.random() * Object.keys(employeeList).length) - 1
  return {
    userId: Object.keys(employeeList)[randomNumber],
    parkings: employeeList[Object.keys(employeeList)[randomNumber]].parkings
  }
}

const SelectRandomParking = (parkings) => {
  const randomNumber = Math.ceil(Math.random() * parkings.length) - 1
  return parkings[randomNumber]
}